import { Button, Modal, Typography, notification } from '@pankod/refine-antd';
import { useOrganizationVatRate } from 'hooks/useOrganizationVatRate';
import { useState } from 'react';
import { getAllCompanyConfig, getCompanyInfo } from 'services/config';
import {
  buildCashMemoReceiptData,
  buildSampleCashMemoSale,
  renderCashMemo,
} from 'utilities/cash-memo';
import { printPosInvoice } from 'utilities/print';
import { showsVat } from 'utilities/sale-vat';
import { getAddressAsString } from 'utilities/shared';

// Stitches S7, behind `pos.cashMemoPreview`: preview the cash memo with sample lines and the real
// company header, without creating a sale.
export const CashMemoSampleButton = () => {
  const { vatRatePercent } = useOrganizationVatRate();
  const [isLoading, setIsLoading] = useState(false);
  const [previewHtml, setPreviewHtml] = useState<string | null>(null);

  const openPreview = async () => {
    setIsLoading(true);
    try {
      const companyConfigs = await getAllCompanyConfig();
      const companyInfo = await getCompanyInfo(companyConfigs[0].id);
      setPreviewHtml(
        renderCashMemo(
          buildCashMemoReceiptData(buildSampleCashMemoSale(vatRatePercent), {
            name: companyInfo.companyName,
            number: companyInfo.companyNumber,
            address: getAddressAsString(companyInfo.address),
            tax: companyInfo.companyVatNo,
            bin: companyInfo.companyBinNo,
          }),
        ),
      );
    } catch (err: any) {
      notification.error({
        message: 'Failed',
        description: err?.message ?? 'Failed to load sample',
      });
    }
    setIsLoading(false);
  };

  return (
    <>
      <Button
        size="large"
        loading={isLoading}
        onClick={openPreview}
        style={{ width: '100%', marginTop: '1rem' }}
      >
        Cash memo sample
      </Button>
      <Modal
        title="Cash memo sample"
        visible={previewHtml !== null}
        onCancel={() => setPreviewHtml(null)}
        okText="Print sample"
        onOk={() => previewHtml && printPosInvoice(previewHtml)}
        width={420}
      >
        <Typography.Text type="secondary">
          Sample lines, nothing is saved.
          {showsVat(vatRatePercent) ? ` VAT ${vatRatePercent}% (your rate).` : ' No VAT: no VAT rate is set.'}
        </Typography.Text>
        {previewHtml && (
          <iframe
            title="Cash memo sample"
            srcDoc={previewHtml}
            style={{ width: '100%', height: 560, border: '1px solid #f0f0f0', marginTop: 12 }}
          />
        )}
      </Modal>
    </>
  );
};
